'use client';
import { Button, Card, message } from 'antd';
import { GalleryComp, PostContactComp } from 'components';
import { GlobalContext } from 'context';
import { API, PATH } from 'data';
import { useContext, useEffect, useState } from 'react';
import { nextBrowser, RestAPI, useAsyncClick, useLongPress, CopyToClipboard } from 'scripts';
import { ChatType, PostType } from 'types';
import styles from './postDetail.module.scss';
import PostReportComp from './report/report.index';
import PostInfoComp from './postInfo/postInfo.index';
import PostTopSectionComp from './topSection/topSection.index';
import PostToolsComp from './tools/tools.index';
import { useRouter } from 'next/navigation';
import { TbMap } from 'react-icons/tb';

function PostDetailComp(props: { post: PostType<'detail'> }) {
    const [post, setPost] = useState(props.post);
    const [infoActive, setInfoActive] = useState(false);
    const [isSpamOpen, setSpamOpen] = useState(false);
    const { profile, categories } = useContext(GlobalContext);
    const router = useRouter();
    const url =
        post.latitude && post.longitude
            ? `geo:${post.latitude},${post.longitude}`
            : 'https://maps.google.com/maps?q=' + post.address;
    const longPressEvent = useLongPress(
        () => {
            if (post.address) {
                CopyToClipboard(post.address);
                message.success('نشانی با موفقیت در کلیپ بورد ذخیره شد');
            }
        },
        () => nextBrowser.window?.open(url),
    );

    const chatHandler = useAsyncClick(() => {
        return new Promise(() => {
            if (post.is_owner) {
                message.warning('این آگهی متعلق به شماست و نمیتوانید با خود چت کنید');
            } else if (!profile) {
                router.push(PATH.login(PATH.postDetail(post.slug)));
            } else {
                RestAPI.post<ChatType>(API.chat.index, { post: post.id }).then((res) => {
                    router.push(PATH.panel.chat({ chatID: res.data.id }));
                });
            }
        });
    });

    const Buttons = (
        <>
            <Button onClick={() => setInfoActive(!infoActive)} className={`w-100`}>
                اطلاعات تماس
            </Button>
            {post.chatable ? (
                <Button className="w-100" {...chatHandler}>
                    چت
                </Button>
            ) : null}
        </>
    );

    useEffect(() => {
        RestAPI.post(API.view.add, { post: post.id });
    }, [profile]);

    // const longPressHandler = useLongPress(
    //     () => {
    //         if (post.address) {
    //             CopyToClipboard(post.address);
    //             message.success('نشانی با موفقیت کپی شد ');
    //         }
    //     },
    //     () => {
    //         console.log('click');
    //     },
    // );

    return (
        <div className={`${styles['detail-layout']}`}>
            <PostToolsComp post={post} setPost={setPost} categories={categories} />
            <div className={`${styles['info-slider-layout']} d-flex`}>
                <div className={`${styles['info']}`}>
                    <PostTopSectionComp post={post} setPost={setPost} />
                    <PostInfoComp post={post} />
                    {post.address?.length ? (
                        <a className="w-100 mb-4 d-block" href={url} target="_blank" {...longPressEvent}>
                            <Card className="w-100 bg-d-bgDark" title="نشانی" extra={<TbMap />}>
                                {post.address}
                            </Card>
                        </a>
                    ) : null}
                    {post.description ? (
                        <div className={`${styles['desc']} mb-4`}>
                            <h3 className="t-h3 t-l-black1 t-d-gray3 t-500 mb-2">توضیحات</h3>
                            <p className="t-p2 t-l-black1 t-d-gray2 t-400">{post.description}</p>
                        </div>
                    ) : null}
                    <PostReportComp
                        postID={post.id.toString()}
                        isReported={post.is_report}
                        open={isSpamOpen}
                        setOpen={setSpamOpen}
                        isOwner={post.is_owner}
                        onReport={() => setPost({ ...post, is_report: true })}
                    />
                    <div className={`${styles['contacts-btns']} center-content g-2 d-md-none mt-3`}>{Buttons}</div>
                </div>
                <div className={`${styles['slider']}`}>
                    <GalleryComp
                        gallery={post.gallery?.length ? post.gallery : post.main_image ? [post.main_image] : undefined}
                        className={styles['gallery']}
                    />
                    <div className={`center-content g-2 d-pre-md-none`}>{Buttons}</div>
                </div>
            </div>
            <PostContactComp open={infoActive} onClose={() => setInfoActive(false)} post={post} />
        </div>
    );
}

export default PostDetailComp;
